import{createContext as r}from"react";var o=r([!1,function(){}]);export{o as AccordionContext};
